import { useContextMotifDetails } from '../../contexts/motifDetailsContext'
import { useContextSelectedMotifs } from '../../contexts/selectedMotifContext'
import { useContextUI } from '../../contexts/UIContext'
import { Motif } from '../../types/motifs'
import { Container } from './styled'
import MotifImageSection from './MotifImageSection'
import MotifInfoSection from './MotifInfoSection'
import MotifGallerySection from './MotifGallerySection'
import SVG from 'react-inlinesvg'
import { isMobile } from 'react-device-detect'

interface Props {
  motif: Motif
}

const MotifDetailsItem = ({ motif }: Props) => {
  const { motifDetailsFadeOut, setDetailsOpen, setMotifDetailsFadeOut } = useContextMotifDetails()
  const { numberOfSelectedMotifs } = useContextSelectedMotifs()
  const { triggerFirstNotification } = useContextUI()

  const handleCloseClick = (event: React.MouseEvent) => {
    event.stopPropagation()
    setMotifDetailsFadeOut(true)
    setTimeout(() => {
      setDetailsOpen(false)
      setMotifDetailsFadeOut(false)
      triggerFirstNotification(numberOfSelectedMotifs)
    }, 500)
  }

  if (isMobile && window.innerHeight < 600) {
    // Mobile-specific
    return (
      <Container>
        <div className={`wrapper mobile ${motifDetailsFadeOut ? 'fade-out' : 'fade-in'}`}>
          <div className="mobile-image-wrapper">
            <MotifImageSection motif={motif} />
            <MotifGallerySection motif={motif} />
          </div>
          <MotifInfoSection motif={motif} />
        </div>
      </Container>
    )
  }
  return (
    <Container>
      <div className={`wrapper ${motifDetailsFadeOut ? 'fade-out' : 'fade-in'}`}>
        <MotifImageSection motif={motif} />
        <MotifInfoSection motif={motif} />
        <MotifGallerySection motif={motif} />
      </div>
    </Container>
  )
}

export default MotifDetailsItem
